import { useGetFeaturesQuery } from '../store/api/featuresApi';

// useFeature(featureKey) → boolean. True when the current merchant's plan
// enables the feature. While loading or on error it returns false (locked by
// default), so gated UI never flashes open before entitlements resolve.
const useFeature = (featureKey) => {
  const { data: features } = useGetFeaturesQuery();
  return Array.isArray(features) && features.includes(featureKey);
};

export default useFeature;
